import _slicedToArray from "/home/runner/work/doctocat/doctocat/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/runner/work/doctocat/doctocat/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "disabled", "onChange", "name"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { createContext } from 'react';
import CheckboxOrRadioGroup from './_CheckboxOrRadioGroup';
import CheckboxOrRadioGroupCaption from './_CheckboxOrRadioGroup/_CheckboxOrRadioGroupCaption';
import CheckboxOrRadioGroupLabel from './_CheckboxOrRadioGroup/_CheckboxOrRadioGroupLabel';
import CheckboxOrRadioGroupValidation from './_CheckboxOrRadioGroup/_CheckboxOrRadioGroupValidation';
import { useRenderForcingRef } from './hooks';
export var RadioGroupContext = /*#__PURE__*/createContext(null);

var RadioGroup = function RadioGroup(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      _onChange = _ref.onChange,
      name = _ref.name,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useRenderForcingRef = useRenderForcingRef(null),
      _useRenderForcingRef2 = _slicedToArray(_useRenderForcingRef, 2),
      selectedRadioValue = _useRenderForcingRef2[0],
      setSelectedRadioValue = _useRenderForcingRef2[1];

  var updateSelectedCheckboxes = function updateSelectedCheckboxes(e) {
    var _e$currentTarget = e.currentTarget,
        value = _e$currentTarget.value,
        checked = _e$currentTarget.checked;

    if (checked) {
      setSelectedRadioValue(value);
      return;
    }
  };

  return /*#__PURE__*/React.createElement(RadioGroupContext.Provider, {
    value: {
      disabled: disabled,
      name: name,
      onChange: function onChange(e) {
        if (_onChange) {
          updateSelectedCheckboxes(e);

          _onChange(selectedRadioValue.current, e);
        }
      }
    }
  }, /*#__PURE__*/React.createElement(CheckboxOrRadioGroup, _extends({
    disabled: disabled
  }, rest), children));
};

RadioGroup.displayName = "RadioGroup";
export default Object.assign(RadioGroup, {
  Caption: CheckboxOrRadioGroupCaption,
  Label: CheckboxOrRadioGroupLabel,
  Validation: CheckboxOrRadioGroupValidation
});